import type { TFunction } from 'i18next';

export type ApiErrorLike = {
  message?: string;
  code?: string;
  status?: number;
  data?: { message?: string; code?: string };
};

const CODE_TO_KEY: Record<string, string> = {
  RATE_LIMIT_EXCEEDED: 'errors.rateLimitExceeded',
  RATE_LIMIT_FRIEND_REQUEST: 'errors.rateLimitFriendRequest',
  RATE_LIMIT_MESSAGE_THREAD: 'errors.rateLimitMessageThread',
  RATE_LIMIT_CONTACT_FORM: 'errors.rateLimitContactForm',
};

const MESSAGE_TO_KEY: Record<string, string> = {
  'Too many requests, please try again later.': 'errors.rateLimitExceeded',
  'Too many friend requests. Please try again later.': 'errors.rateLimitFriendRequest',
  'Too many new conversations. Please try again later.': 'errors.rateLimitMessageThread',
  'Too many contact form submissions. Please try again later.': 'errors.rateLimitContactForm',
};

export function translateApiError(
  t: TFunction,
  error: ApiErrorLike,
  fallbackKey?: string,
): string {
  const code = error.code || error.data?.code;
  const message = error.message || error.data?.message;

  if (code && CODE_TO_KEY[code]) {
    return t(CODE_TO_KEY[code]);
  }
  if (message && MESSAGE_TO_KEY[message]) {
    return t(MESSAGE_TO_KEY[message]);
  }
  if (error.status === 429) {
    return t('errors.rateLimitExceeded');
  }
  if (message) {
    return message;
  }
  return fallbackKey ? t(fallbackKey) : '';
}
